import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import {
  MAXIMUM_ALLOWED_COMMAND_LINES_COUNT,
  MAXIMUM_COMMAND_LINE_LENGTH,
  SubmitToSandboxSettingsFormWebComponentSchema,
} from '../types';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { GzTextWebComponent } from '../../../../../ui/gzText';
import { GzInputTextGridWebComponent } from '../../../../../ui/gzInputTextGrid';
import { translateFn } from '../../../../../utils/translator.helper';
import { MaxLengthValidator } from '../../../../../ui/gzForm/validators/max-length.validator';

export class SubmitToSandboxSettingsFormView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $title: GzTitleWebComponent;
    $description: GzTextWebComponent;
    $inputGrid: GzInputTextGridWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#wrapper'),
      $title: this.shadow.querySelector('#title'),
      $description: this.shadow.querySelector('#description'),
      $inputGrid: this.shadow.querySelector('#input-grid'),
    };

    this.setTranslatedStrings();
  }

  setTranslatedStrings() {
    this.dom.$title.innerHTML = translateFn('Detonation settings');

    this.dom.$description.innerHTML = translateFn(
      'Optionally, add command lines to be executed when the detonation starts.<br>Command lines may include parameters. Executable files, such as interpreters, must include the full path. For example, <strong>C:\\Windows\\System32\\WindowsPowerShell\\v1.0\\powershell.exe C:\\script.ps1</strong>.<br>If nothing is specified, Sandbox Analyzer will automatically choose how to detonate the samples.<br>You can add up to 10 command lines per submission.'
    );

    this.dom.$inputGrid.label = translateFn('Add command line');
    this.dom.$inputGrid.placeholder = translateFn('Specify the command line');
    this.dom.$inputGrid.columnName = translateFn('Command line');
    this.dom.$inputGrid.emptyStateButtonLinkText = translateFn('Add command line');
  }

  buildView(data: SubmitToSandboxSettingsFormWebComponentSchema) {
    this.dom.$inputGrid.duplicateErrorMessage = translateFn('The command line already exists.');
    this.dom.$inputGrid.maxItems = MAXIMUM_ALLOWED_COMMAND_LINES_COUNT;
    this.dom.$inputGrid.maxItemsReachedErrorMessage = translateFn(
      'The limit of {maxCommandLines} command lines has been reached.',
      { maxCommandLines: MAXIMUM_ALLOWED_COMMAND_LINES_COUNT }
    );

    this.dom.$inputGrid.InputValidators = [
      MaxLengthValidator(
        MAXIMUM_COMMAND_LINE_LENGTH,
        translateFn('The command line must have a maximum of {maxLength} characters.', {
          maxLength: MAXIMUM_COMMAND_LINE_LENGTH,
        })
      ),
    ];
  }
}
